export class CfetTitlesConstant {
    public static CFET_TITLES = {
        landing: {
            htmlTitle: 'FirstNet | Public Safety Communications for First Responder & Healthcare representatives'
        },
        eligibility: {
            htmlTitle: 'Eligibility - FirstNet, Built with AT&T',
            utfHtmlTitle: 'Eligibility - FirstNet, Built with AT&T'
        },
        information: {
            htmlTitle: 'Information – FirstNet, Built with AT&T',
            utfHtmlTitle: 'Information – FirstNet, Built with AT&T'
        },
        profile: {
            htmlTitle: 'Profile – FirstNet, Built with AT&T',
            utfHtmlTitle: 'Profile Update – FirstNet, Built with AT&T'
        },
        agency: {
            htmlTitle: 'Agency details – FirstNet, Built with AT&T'
        },
        success: {
            utfHtmlTitle: 'Success – FirstNet, Built with AT&T'
        },
        confirmation: {
            utfHtmlTitle: 'Confirmation – FirstNet, Built with AT&T'
        },
        timeout: {
            htmlTitle: 'Session time out'
        }
    };
}